import { COMMON_QUERY_PARAMS } from "taskpane/constants/queryParams";
import { ICommonQueryParams, IQueryResponse } from "taskpane/models/interfaces";
import useQuery, { IPostData } from "./useQuery";
import { encodeUriParams } from "taskpane/utils";
import { OnReady } from "taskpane/models/types";
import { getQueryErrorDescription, getQueryErrorInvalidLoginOrPassword } from "taskpane/resources";
import { ContentType, LoginStatusCode } from "taskpane/models/enums";

interface ILoginQueryParams extends ICommonQueryParams {
  tokenType: "otp_via_email" | "longTerm";
  s: string;
}

export interface IQueryLogin {
  apiUrl: string;
  email: string;
  password?: string;
}

export interface IQueryLoginResponse {
  response: {
    statusCode: number;
    statusText: string;
    data?: {
      token?: {
        a?: string;
      };
    };
  };
}

const useQueryLogin = (params: IQueryLogin, onReady: OnReady<IQueryResponse<IQueryLoginResponse>>): void => {
  const { apiUrl, email, password } = params;
  const queryParams: ILoginQueryParams = {
    ...COMMON_QUERY_PARAMS,
    tokenType: password ? "longTerm" : "otp_via_email",
    s: email,
  };
  const url: string = `${apiUrl}/wim/auth/clientLogin${encodeUriParams(queryParams)}`;
  const postData: IPostData = {
    data: {
      pwd: password ?? "1",
    },
    contentType: ContentType.formUrlEncoded,
  };

  useQuery(
    url,
    "POST",
    (result: IQueryResponse<IQueryLoginResponse>) => {
      if (result.errorMessage) {
        return onReady(result);
      }

      const { statusCode, statusText } = result.response.response;

      if (statusCode === LoginStatusCode.invalidLoginOrPassword) {
        return onReady({
          ...result,
          errorMessage: getQueryErrorInvalidLoginOrPassword(),
        });
      } else if (statusCode !== LoginStatusCode.successed) {
        return onReady({
          ...result,
          errorMessage: getQueryErrorDescription(statusCode, statusText),
        });
      }

      return onReady(result);
    },
    postData
  );
};

export default useQueryLogin;
